import React from 'react';

function CategoryTabItem({
    category,
    idx,
    activeCategory,
    setActiveCategory,
    editingCategoryIndex,
    setEditingCategoryIndex,
    categories,
    setCategories,
    todoLists,
    setTodoLists,
    userId,
    inputCatRef
}) {
    return (
        <li className="nav-item">
            {/* 編集モード */}
            {editingCategoryIndex === idx ? (
                <input
                    type="text"
                    className="form-control"
                    autoFocus
                    ref={inputCatRef}
                    defaultValue={category}
                    // フォーカスが外れたとき
                    onBlur={() => {
                        const inputCatValue = inputCatRef.current.value.trim();
                        if (inputCatValue && inputCatValue !== category) {
                            // カテゴリ名が変更されたときのみ以下処理を行う
                            const newCategories = [...categories];
                            newCategories[idx] = inputCatValue;

                            // カテゴリ名を更新
                            setCategories(newCategories);
                            localStorage.setItem(userId + '_categories', JSON.stringify(newCategories));

                            const newTodoLists = { ...todoLists };
                            newTodoLists[inputCatValue] = newTodoLists[category] || [];

                            // TODOリストのカテゴリ名を更新
                            delete newTodoLists[category];
                            setTodoLists(newTodoLists);
                            localStorage.setItem(userId, JSON.stringify(newTodoLists));
                        }
                        setEditingCategoryIndex(null);
                    }}
                    onKeyDown={e => {
                        if (e.key === 'Enter') {
                            e.target.blur();
                        }
                    }}
                    style={{ minWidth: '100px' }}
                />
            ) : (
                <a
                    className={`nav-link${activeCategory === idx ? ' active' : ''}`}
                    href="#"
                    aria-current={activeCategory === idx ? 'page' : undefined}
                    onClick={e => {
                        e.preventDefault();
                        setActiveCategory(idx);
                    }}
                    onDoubleClick={() => {
                        setEditingCategoryIndex(idx);
                    }}
                    title="ダブルクリックで名前変更"
                >
                    {category}
                </a>
            )}
        </li>
    );
}

export default CategoryTabItem;
